export default __webpack_public_path__ + "static/media/makro-light.0b2071df.svg";